<!-- 发运量趋势统计 -->
<template>
  <div>
    <el-card>
      <div class="title">
        <p>发运量趋势统计</p>
      </div>
      <div id="trend"></div>
    </el-card>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card style="margin-top: 20px;">
          <div class="title">
            <p>月度计划</p>
            <el-date-picker v-model="value2" type="month" placeholder="选择月">
            </el-date-picker>
          </div>
          <div class="progress">
            <div class="progress-title">
              <p>月度计划完成进度</p>
              <p>78%</p>
            </div>
            <el-progress :percentage="78" color="#2563EB" :show-text="false" :stroke-width="10"></el-progress>
          </div>
          <el-card shadow="never" v-for="(item, index) in list" :key="index" style="margin-top: 20px;">
            <div class="list-title">
              <div>
                <p>{{ item.lable }}</p>
                <p>计划编号: {{ item.num }}</p>
              </div>
              <p>{{ item.progress }}%</p>
            </div>
            <p class="list-info">
              <span v-if="item.plan">计划量: {{ item.plan }}吨 ｜</span>
              <span v-if="item.completed">已完成: {{ item.completed }}吨 ｜</span>
              <span v-if="item.type">物资类型: {{ item.type }}</span>
            </p>
          </el-card>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="margin-top: 20px;">
          <div class="title">
            <p>日计划</p>
            <el-date-picker v-model="value2" type="date" placeholder="选择日期">
            </el-date-picker>
          </div>

        </el-card>
      </el-col>
    </el-row>

    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';

export default {
  name: "store-management/index/index",
  components: {
  },
  data() {
    return {
      value2: '',
      list: [{
        lable: '上海宝钢集团',
        num: 'P202401001',
        progress: 85,
        plan: 2500,
        completed: 2125,
        type: '煤'
      }, {
        lable: '江苏徐工机械',
        num: 'P202401002',
        progress: 45,
        plan: 1500,
        completed: 825,
      }, {
        lable: '广东中集集团',
        num: 'P202401003',
        progress: 30,
        plan: 3000,
        completed: 900,
      }]
    };
  },
  mounted() {
    this.trendInit()
  },
  methods: {
    trendInit() {
      let chartDom = document.getElementById('trend');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          show: true,
          right: 10,
          textStyle: {
            color: '#374151',
            fontSize: 14,
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            name: '日发运量',
            data: [820, 932, 1101, 1234, 1290, 1330],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#10b981',
              width: 2,
            },
            itemStyle: {
              color: '#10b981',
            },
          }, {
            name: '周发运量',
            data: [68, 21, 41, 51, 64, 98],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#2563eb',
              width: 2,
            },
            itemStyle: {
              color: '#2563eb',
            },
          }, {
            name: '月发运量',
            data: [135, 136, 157, 138, 277, 146],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#6e7079',
              width: 2,
            },
            itemStyle: {
              color: '#6e7079',
            },
          }
        ]
      };
      option && myChart.setOption(option);
    },
  }
};
</script>
<style scoped lang="scss">
#trend {
  width: 100%;
  height: 400px;
}

p {
  margin: 0;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 18px;
    font-weight: 600;
    color: #1F2937;
  }
}

.progress {
  margin-top: 30px;

  .progress-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    p {
      font-size: 14px;
      font-weight: 500;

      &:nth-child(1) {
        color: #6B7280;
      }

      &:nth-child(2) {
        color: #2563EB;
      }
    }
  }
}

.list-title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    p {
      &:nth-child(1) {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
      }

      &:nth-child(2) {
        font-size: 14px;
        color: #6B7280;
        line-height: 36px;
      }
    }
  }

  p {
    color: #2563EB;
    font-size: 16px;
    font-weight: 500;
  }
}

.list-info {
  color: #6B7280;
  font-size: 14px;
  margin-top: 12px;

  span {
    margin-right: 10px;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>